import { render, staticRenderFns } from "./TalkTrendBasePage.vue?vue&type=template&id=fa8ef59a&scoped=true"
import script from "./TalkTrendBasePage.vue?vue&type=script&lang=js"
export * from "./TalkTrendBasePage.vue?vue&type=script&lang=js"
import style0 from "./TalkTrendBasePage.vue?vue&type=style&index=0&id=fa8ef59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8ef59a",
  null
  
)

export default component.exports